import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { useAuth } from '@/contexts/AuthContext';
import { getInitials } from '@/lib/utils';

export default function DashboardHeader() {
  const { user } = useAuth();
  
  return (
    <header className="border-b bg-background py-3 px-4 lg:px-8 flex items-center justify-between">
      <div></div>
      
      <div className="flex items-center space-x-4">
        <ThemeToggle />
        
        <div className="flex items-center space-x-3">
          <Avatar>
            <AvatarImage src={user?.avatar_url} alt={user?.name} />
            <AvatarFallback>{getInitials(user?.name || '')}</AvatarFallback>
          </Avatar>
          <div className="hidden md:block">
            <p className="font-medium text-sm">{user?.name}</p>
            <p className="text-xs text-muted-foreground">{user?.email}</p>
          </div>
        </div>
      </div>
    </header>
  );
}